<template>
  <Section id="faq" class="faq">
    <div class="componata-container --is-narrow">
      <SectionHeader>
        <template v-slot:title>Häufige Fragen</template>
      </SectionHeader>

      <ul
        v-if="data.length > 1"
        class="faq__categories"
      >
        <li
          v-for="(item, index) in data"
          :key="index"
          @click="toggleCategory(index)"
          class="faq__category"
          :class="{ '--is-active' : index === activeCategoryIndex }"
        >
          {{ item.categoryName }}
        </li>
      </ul>

      <article>
        <ul
          v-for="(category, categoryIndex) in data"
          :key="categoryIndex"
          v-show="activeCategoryIndex === categoryIndex"
          class="faq__list"
        >
          <li
            v-for="(question, questionIndex) in category.questions"
            :key="questionIndex"
            class="faq__item"
            :class="{'--is-open' : question.isVisible}"
          >
            <h4 class="faq__question" @click="toggleQuestion(categoryIndex, questionIndex)">{{question.question}}</h4>
            <div class="faq__answer" v-html="question.answer"></div>
          </li>
        </ul>

        <div class="faq__footer">
          <h3 class="faq__footer-title">Haben Sie weitere Fragen?</h3>

          <p class="faq__footer-line"><a href="mailto:kundenservice@componata.de" v-on:click="trackMail"><i class="icon icon-envelope"></i> kundenservice@componata.de</a> <span>oder</span> <a href="tel:034198992080" v-on:click="trackPhone"><i class="icon icon-phone"></i> 0341 9899 2080</a></p>
        </div>
      </article>
    </div>
  </Section>
</template>

<script>
import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';

export default {
  name: 'Faq',
  components: {
    Section,
    SectionHeader
  },
  props: ['data'],
  data () {
    return {
      activeCategoryIndex: 0
    };
  },
  methods: {
    toggleCategory (categoryIndex) {
      this.activeCategoryIndex = categoryIndex;
    },
    trackMail() {
      this.trackEvent('mailContactClicked');
    },
    trackPhone() {
      this.trackEvent('phoneContactClicked');
    },
    trackEvent(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        campaing: this.landingPageName
      });
    },
    toggleQuestion (categoryIndex, questionIndex) {
      if (this.data[categoryIndex].questions[questionIndex].isVisible) {
        this.data[categoryIndex].questions[questionIndex].isVisible = false;
      } else {
        if ('isVisible' in this.data[categoryIndex].questions[questionIndex] === false) {
          this.$set(this.data[categoryIndex].questions[questionIndex], 'isVisible', true);
        }

        this.data[categoryIndex].questions[questionIndex].isVisible = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Faq
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Frequently asked questions section
 * @since 2021-01-22
**/

$component: 'faq';
$white: #F9FAFB;
$blue: #6AC2FF;

.#{$component} {
  @include linear-gradient(to bottom, #222222 50%, $ink);
  color: $white;

  &__categories {
    @include unlist;
    display: flex;
    justify-content: center;
    @include margin-bottom(map-get($spacers, 5));
    @include font-size(map-get($landing-page, 'font-size-lg'));
  }

  &__category {
    @include padding(map-get($spacers, 2) map-get($spacers, 3));
    border-radius: $border-radius-lg;
    color: $ink-lighter;
    cursor: pointer;

    &:not(:last-child) {
      @include margin-right(map-get($spacers, 2));
    }

    @include hover() {
      background-color: rgba($ink-light, 0.3);
    }

    &.--is-active {
      background-color: $ink-light;
      color: $blue;
    }
  }

  &__list {
    @include unlist;
    width: 72%;
    margin-left: auto;
    margin-right: auto;
  }

  &__item {
    position: relative;
    border-bottom: 1px solid rgba($ink-light, 50%);

    &.--is-open {
      .#{$component} {
        &__question {
          &:after {
            transform: rotate(44deg);
          }
        }

        &__answer {
          max-height: 500px;
          opacity: 1;
          transition: all 0.3s ease;
        }
      }
    }
  }

  &__question {
    margin: 0;
    @include padding-top(map-get($spacers, 4));
    @include padding-right(map-get($spacers, 6));
    @include padding-bottom(map-get($spacers, 4));
    @include font-size(map-get($landing-page, 'font-size-lg'));
    font-weight: $font-weight-normal;
    cursor: pointer;

    &:after {
      position: absolute;
      @include rfs(map-get($spacers, 3) * 1.3, top);
      right: 0;
      display: inline-block;
      content: '\e91c';
      @include icomoon;
      @include font-size(map-get($landing-page, 'font-size-lg') * 1.5);
      transition: transform 0.2s ease-in-out;
    }

    &:hover {
      color: $blue;
    }
  }

  &__answer {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    @include padding-right(map-get($spacers, 6));
    color: $sky-dark;
    // font-weight: $font-weight-light;
    line-height: 160%;

    > p:last-child {
      margin-bottom: 0;
    }

    // p + p {
    //   @include margin-top(map-get($spacers, 2));
    // }
  }

  // Footer
  &__list + &__footer {
    @include margin-top(map-get($spacers, 7));
  }

  &__footer {
    text-align: center;

    a {
      color: $white;
      text-decoration: none;

      &:hover {
        color: $blue;
      }
    }
  }

  &__footer-title {
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($landing-page, 'font-size-lg'));
  }

  &__footer-line {
    margin: 0;

    span {
      display: inline-block;
      @include margin-left(map-get($spacers, 2));
      @include margin-right(map-get($spacers, 2));
      color: $ink-lightest;
    }
    .icon {
      vertical-align: bottom;
      @include margin-right(map-get($spacers, 1));
      color: $blue;
      @include font-size(map-get($landing-page, 'font-size-xl'));
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
    &__list {
      width: 80%;
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__list {
      width: 90%;
    }

    &__footer-line {
      span {
        display: block;
        @include margin-top(map-get($spacers, 2));
        @include margin-bottom(map-get($spacers, 2));
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__list {
      width: 100%;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
